import React, { useState, useRef } from 'react';
import mainbackground from '../../images/mainbackground.jpg';
import emailjs from '@emailjs/browser';


import { validateEmail } from '../../utils/helpers';

function ContactForm() {
  
  const form = useRef();
  //const navigate = useNavigate();

  const [text, setText] = useState('');

  const sendEmail = (e) => {
    e.preventDefault();
    setText('Sending message ... ...')

    emailjs.sendForm('service_8fa6sia', 'template_ihn9to3', form.current, 'nRTm6yqP4fE1PvTX3')
      .then((result) => {
          console.log(result.text);
          setText('Your message has been sent!');
          //window.location.href = '/Thank';;
      }, (error) => {
          console.log(error.text);
          
      });
    
    
      
  };

  return (
    <section className="contact-form" style={{backgroundImage:`url(${mainbackground})`}}>
      
      <h1 className="contact-form-title" data-testid="h1tag">Contact me</h1>

      <form id="contact-form" ref={form} onSubmit={sendEmail}>
      <label className='contact-form-label'>Name</label>
      <input className='contact-form-input' type="text" name="name" />
      <br/>
      <label className='contact-form-label'>Email</label>
      <input className='contact-form-input' type="email" name="email" />
      <br/>
      <br/>
      <label className='contact-form-label'  >Message</label>
      <textarea className='contact-form-input' name="message" />
      <br/>
     
      
      <input type="submit" value="Send" className='contact-form-button' style={{textAlign:"center", backgroundColor:"azure", borderRadius:"5px", fontFamily:"cursive"}}/>
      
      
    </form>
    <h3 style={{marginLeft:"100px", marginTop:"40px", fontFamily:"cursive",color:"black" }}>{text}</h3>
    </section>
    
  );
}

export default ContactForm;
